import { fetchAuthSession } from "aws-amplify/auth";

// env
const { REACT_APP_SETTINGS_API_BASEURL } = process.env;

export const settingsApiRequest = async ({ method = 'GET', path, body = null }) => {
  const { tokens } = await fetchAuthSession();
  const idToken = tokens?.idToken?.toString();

  const res = await fetch(`${REACT_APP_SETTINGS_API_BASEURL}${path}`, {
    method,
    headers: {
      Authorization: idToken,
      ...(body && { 'Content-Type': 'application/json' }),
    },
    ...(body && { body: JSON.stringify(body) }),
  });

  if (!res.ok) {
    // error body shape
    let message = 'Something went wrong';
    try {
      const errBody = await res.json();
      message = errBody?.Message || message;
    } catch (_) { /* non-JSON error body */ }

    const error = new Error(message);
    error.status = res.status;
    throw error;
  }

  // DELETE may return an empty body
  if (res.status === 204) return {};
  return await res.json();
};
